import React, { Component } from "react";
import Styles from './styles.module.css';
import { Col } from "reactstrap";
import { ReactComponent as BackArrow } from '../../../../Assets/svg/back-arrow.svg';

export default class MainTile extends Component<{image:string}>{
    render(){
        return (
            <Col xs="12">
                <div>
                    <div className={Styles.backContainer}>
                        <BackArrow />
                        <span>Shop</span>
                    </div>
                    <img className={Styles.image} src={this.props.image}/>
                    <button className={Styles.buy}>BUY NOW</button>
                </div>
            </Col>
        )
    }
}